// src/components/Dealer/AddDealerForm.js
import React from 'react';
import { Modal, Form, Input, Button, Spin } from 'antd';

const AddDealerForm = ({ visible, onCancel, onAddDealer, loading }) => {
  const [form] = Form.useForm();

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      onAddDealer(values);
    }).catch((info) => {
      console.log('Validate Failed:', info);
    });
  };

  return (
    <Modal
      visible={visible}
      title="新增經銷商"
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit} loading={loading}>
          Send
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" autoComplete="off">
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please input the name!' }]}
          >
            <Input disabled={loading} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default AddDealerForm;